import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { WalletProvider } from './context/WalletContext';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Explore from './pages/Explore';
import TokenDetail from './pages/TokenDetail';
import ChatWidget from './components/ChatWidget';
import NewLaunchNotifier from './components/NewLaunchNotifier';
import AdminOverlay from './components/AdminOverlay';
import './App.css';

function App() {
  return (
    <WalletProvider>
      <BrowserRouter>
        <div className="min-h-screen text-white font-body">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/token/:address" element={<TokenDetail />} />
            </Routes>
          </main>
          <footer className="border-t border-white/5 py-8 mt-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-forge-muted">
              <span className="font-display font-medium">CoinForge · forge your coin in two clicks</span>
              <span>1.0% platform · 0.5% creator · 98.5% recipient</span>
            </div>
          </footer>
        </div>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            className: 'bg-[#0B0A2A]/95 backdrop-blur-xl border border-white/10 rounded-2xl text-white font-body text-sm',
          }}
        />
        <ChatWidget />
        <NewLaunchNotifier />
        <AdminOverlay />
      </BrowserRouter>
    </WalletProvider>
  );
}

export default App;
